import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router';
import SGPCompany from './SGPCompany';
import { texts } from 'utils/languages/fr';
import { ListContainer } from 'components';
import SGPCompaniesTable from './SGPCompaniesTable';

const SGPCompanies = () => {
    const { path } = useRouteMatch();

    return (
        <ListContainer>
            <Switch>
                <Route path={path} exact component={SGPCompaniesTable} />
                <Route
                    path={`${path}/create`}
                    title={texts.SGP_CREATE_PROVIDER}
                    component={SGPCompany}
                />
                <Route
                    path={`${path}/edit/:id`}
                    title={texts.SGP_EDIT_PROVIDER}
                    component={SGPCompany}
                />
            </Switch>
        </ListContainer>
    );
};

export default SGPCompanies;
